import React, { useCallback } from 'react';
import { GenericInputModal } from '@ydistri/ds';
import { useCreateAsoRequestMutation } from '../apiAso';
import { useNavigate } from 'react-router';
import { useStableParams } from '../../../routes/useStableParams';
import { generatePartialPath } from '../../../routes/routerSlice';
import { ROUTES } from '../../../components/menu/getMenuLeftItems';

interface CreateAsoRequestModalProps {
  open: boolean;
  onCancel: () => void;
}

const CreateAsoRequestModal: React.FC<CreateAsoRequestModalProps> = ({ open, onCancel }) => {
  const [createAsoRequest, { isLoading: confirmLoading }] = useCreateAsoRequestMutation();
  const navigate = useNavigate();
  const { projectShortName } = useStableParams();

  const handleConfirm = useCallback(
    (name: string) => {
      createAsoRequest({ name }).then(response => {
        if ('data' in response && response.data?.id) {
          const params: Record<string, string | undefined> = {
            projectShortName,
            asoRequestId: String(response.data.id),
          };

          const path = generatePartialPath(ROUTES.asoChildRoute, params, undefined);
          navigate(path);
        }

        onCancel();
      });
    },
    [createAsoRequest, navigate, onCancel, projectShortName],
  );

  if (!open) return null;

  return (
    <GenericInputModal
      title="Create ASO request"
      placeholder="Name"
      onConfirmed={handleConfirm}
      onClose={onCancel}
      submitButtonLabel="Create"
      requiredMessage="Please enter a name for your ASO request"
      confirmLoading={confirmLoading}
    />
  );
};

export default CreateAsoRequestModal;
